import ApiService from "./api.service";
import { downloadAxiosBlobResponse } from "@/utils/blobDownload";

const PortalAnalyticsService = {
  async downloadExcel(type) {
    const response = await ApiService.get(`portal/analytics/excel/${type}`, {
      responseType: "blob",
    });

    downloadAxiosBlobResponse(response, `portal-analytics-${type}.xlsx`);
  },
};

export { PortalAnalyticsService };
